import { useState } from "react";
import Menu from "../assets/icons/menu.svg?react";
import { logOut } from "@/util/auth";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <header className="top-0 w-full z-50 px-4 py-6 flex justify-between items-center">
      <img src="/logo-dark.png" alt="Epsilon" className="h-10" />

      <div className="relative">
        <button onClick={handleMenuToggle} className="p-2 focus:outline-none">
          <Menu color="black" height={24} width={24} />
        </button>
        {menuOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
            <button
              onClick={() => logOut()}
              className="block w-full px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-200 text-left focus:outline-none focus:bg-gray-100"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
